import { render } from "./DeptPicker.vue?vue&type=template&id=2676054c&scoped=true&ts=true"
import script from "./DeptPicker.vue?vue&type=script&lang=ts"
export * from "./DeptPicker.vue?vue&type=script&lang=ts"

import "./DeptPicker.vue?vue&type=style&index=0&id=2676054c&scoped=true&lang=css"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2676054c"]])

export default __exports__